import type { MeterBucket, RegisterChip } from './types/index.ts';

export const REGISTER_CHIPS: ReadonlyArray<{ value: RegisterChip; label: string }> = [
  { value: 'VN', label: 'VN' },
  { value: 'Wave', label: 'Wave' },
  { value: 'Unknown', label: 'Unknown' },
];

export const METER_CHIPS: ReadonlyArray<{ value: MeterBucket; label: string }> = [
  { value: 'Residential', label: 'Residential' },
  { value: 'Commercial', label: 'Commercial' },
  { value: 'Hydrant', label: 'Hydrant' },
  { value: 'Unknown', label: 'Unknown' },
];

export const PRODUCT_TYPE_FILTER_PARAMS = {
  register: 'registerType',
  meter: 'meterType',
} as const;

const REGISTER_VALUES = new Set<string>(REGISTER_CHIPS.map((c) => c.value));
const METER_VALUES = new Set<string>(METER_CHIPS.map((c) => c.value));

function parseChips<T extends string>(raw: string | null, allowed: Set<string>): T[] {
  if (!raw) return [];
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter((v): v is T => v !== '' && allowed.has(v));
}

export function parseRegisterChips(raw: string | null): RegisterChip[] {
  return parseChips<RegisterChip>(raw, REGISTER_VALUES);
}

export function parseMeterChips(raw: string | null): MeterBucket[] {
  return parseChips<MeterBucket>(raw, METER_VALUES);
}

export function serializeChips(values: ReadonlyArray<string>): string | null {
  if (values.length === 0) return null;
  return values.join(',');
}
